import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumb from "component/common/breadcrumb";
import strings from "translate/language";
import { handleDetailResponse, seo } from "utils/utils";
import { getRegistrationDetails } from "../../reduxStore/action/registrationActions";

const ViewRegistration = () => {
  const dispatch = useDispatch();
  const [registrationDetails, setRegistrationDetails] = useState({});
  const params = useParams();
  const { registration_id = "" } = params || {};

  const registrationDetailSelector = useSelector((state) => state.registration);

  useEffect(() => {
    dispatch(getRegistrationDetails({ registration_id }));
  }, [dispatch, registration_id]);

  useEffect(() => {
    if (registrationDetailSelector.response) {
      const { response } = registrationDetailSelector;
      if (response?.status === 200) {
        setRegistrationDetails(handleDetailResponse(response?.data));
      } else {
        setRegistrationDetails({});
      }
    }
  }, [registrationDetailSelector]);

  useEffect(() => {
    seo({
      title: "Registration Details",
      metaDescription: "Registration details",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.registration}
        url={"/registration"}
        parentListing={strings.registraionListing}
        titleactive={strings.viewRegistraion}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header">
                <h5>{strings.viewRegistraion}</h5>
              </div>
              <div className="card-body pt-0">
                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      <h6>{strings.visitScore} : </h6>
                    </label>
                  </div>
                  <div className="col-md-7 ">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      <h6>{registrationDetails?.leads?.lead_score || 0}</h6>
                    </label>
                  </div>
                </div>
                <hr />

                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.customerName} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {registrationDetails?.leads?.customer?.first_name ||
                        strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />

                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.leadby} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {registrationDetails?.visit_create_by?.user_name ||
                        strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.location} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {registrationDetails?.leads?.customer?.location ||
                        strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />

                <div className="row pt-0">
                  <div className="col-md-3 align-items-center ">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.configuration} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center ">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {registrationDetails?.configuration ||
                        strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />

                <div className="row pt-0">
                  <div className="col-md-3 align-items-center ">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.Area} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center ">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {registrationDetails.leads?.areain_sqlft ||
                        strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.budget} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {registrationDetails?.leads?.budget?.min_budget &&
                        registrationDetails?.leads?.budget?.max_budget
                        ? `${registrationDetails?.leads?.budget?.min_budget}${registrationDetails?.leads?.budget?.min_budget_type} - ${registrationDetails?.leads?.budget?.max_budget}${registrationDetails?.leads?.budget?.max_budget_type}`
                        : strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.currentStatus} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {"Registered"}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.propertyName} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {registrationDetails?.properties?.property_title ||
                        strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.bookingBy} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {registrationDetails?.bookings?.booking_by?.user_name ||
                        strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.registerAmount} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {registrationDetails?.total_amount &&
                        registrationDetails?.total_amount_type
                        ? `${registrationDetails?.total_amount} ${registrationDetails?.total_amount_type}`
                        : "Not available"}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.paymentMode} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {registrationDetails?.bookings?.payment_type ||
                        strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.chequeNumber} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {registrationDetails?.bookings
                        ?.tranjection_upi_cheque_number || strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.registerBy} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {registrationDetails?.register_by_name ||
                        strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.confiQty} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {registrationDetails?.configuration &&
                        registrationDetails?.quantity
                        ? `${registrationDetails?.configuration} / ${registrationDetails?.quantity}`
                        : "Not available"}
                    </label>
                  </div>
                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ViewRegistration;
